"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _constants = _interopRequireDefault(require("@ahmdigital/constants"));
var _moment = _interopRequireDefault(require("moment"));
var _getPromoCode2 = _interopRequireDefault(require("../../unqualified/get-promo-code"));
var _getHeaderSentence = _interopRequireDefault(require("../get-header-sentence"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getOfferEndDate = function getOfferEndDate(offer) {
  var _offer$release;
  var offerEndDate = offer === null || offer === void 0 || (_offer$release = offer.release) === null || _offer$release === void 0 ? void 0 : _offer$release.endTime;
  return offerEndDate ? (0, _moment["default"])(offerEndDate).format(_constants["default"].DATE_FORMAT.HUMAN) : null;
};
var getOfferCodeType = function getOfferCodeType(offer) {
  var _offer$canBeRedeemedW;
  return (offer === null || offer === void 0 || (_offer$canBeRedeemedW = offer.canBeRedeemedWithPromoCode) === null || _offer$canBeRedeemedW === void 0 || (_offer$canBeRedeemedW = _offer$canBeRedeemedW[0]) === null || _offer$canBeRedeemedW === void 0 ? void 0 : _offer$canBeRedeemedW.codeType) || _constants["default"].OFFER_CODE_TYPE.PROMO;
};
var replacePlaceholder = function replacePlaceholder(_ref) {
  var offer = _ref.offer,
    offerTypeId = _ref.offerTypeId,
    placeholderId = _ref.placeholderId,
    rewards = _ref.rewards;
  switch (placeholderId) {
    case 'fulfilled-after-days':
      {
        var _offer$offerTypes, _offerType$fulfilledA;
        var offerTypes = (_offer$offerTypes = offer === null || offer === void 0 ? void 0 : offer.offerTypes) !== null && _offer$offerTypes !== void 0 ? _offer$offerTypes : [];
        var offerType = (0, _fp.find)({
          _id: offerTypeId
        }, offerTypes);
        return (_offerType$fulfilledA = offerType === null || offerType === void 0 ? void 0 : offerType.fulfilledAfterDays) !== null && _offerType$fulfilledA !== void 0 ? _offerType$fulfilledA : null;
      }
    case 'promo-code':
      {
        var _getPromoCode$value, _getPromoCode;
        return getOfferCodeType(offer) === _constants["default"].OFFER_CODE_TYPE.PROMO ? (_getPromoCode$value = (_getPromoCode = (0, _getPromoCode2["default"])(offer)) === null || _getPromoCode === void 0 ? void 0 : _getPromoCode.value) !== null && _getPromoCode$value !== void 0 ? _getPromoCode$value : null : '';
      }
    case 'release-end-date-day-month-year':
      {
        return getOfferEndDate(offer);
      }
    case 'reward':
      {
        return (0, _getHeaderSentence["default"])({
          offer: offer,
          rewards: rewards
        });
      }
    case 'code-type':
      {
        return getOfferCodeType(offer);
      }
    case 'minimum-gap-in-cover-days':
      {
        var _offer$minimumGapInCo;
        return (_offer$minimumGapInCo = offer === null || offer === void 0 ? void 0 : offer.minimumGapInCoverDays) !== null && _offer$minimumGapInCo !== void 0 ? _offer$minimumGapInCo : null;
      }
    case 'on-or-before-release-end-date':
      {
        var offerEndDate = getOfferEndDate(offer);
        return offerEndDate ? " on or before ".concat(offerEndDate) : '';
      }
    default:
      return null;
  }
};
var _default = exports["default"] = replacePlaceholder;
module.exports = exports.default;